import { clipHourlyCountsQuery } from "../queries";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import type { ClientApiFeatureSubPathParams } from "@visioni/a3s-client-api";
import type { CountClipsByHourQueryParams, HourCount } from "../../client-messages/clips";

export type UseClipHourlyCountsOptions = ClientApiFeatureSubPathParams &
  CountClipsByHourQueryParams & {
    enabled?: boolean;
  };

/**
 * Fetch clip counts grouped by hour for a camera on a given date.
 * The server resolves timezone-aware day boundaries.
 */
export function useClipHourlyCounts(options: UseClipHourlyCountsOptions): UseQueryResult<HourCount[]> {
  const apiConfig = useApiConfig();
  const { enabled = true, date, timezone, ...pathParams } = options;

  const queryParams = { date, timezone };

  return useQuery({
    ...clipHourlyCountsQuery(apiConfig, pathParams, queryParams),
    enabled,
    select: (response) => response.data,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}
